<!-- <div class="not-found-section">
    <div class="col-md-12 not-found-body">
        <img src="assets/img/logo/not-found.gif" alt="">
        <h4>Coming Soon!</h4>
        <p>{{comingSoonMsg}}</p>

    </div>
</div> -->
<div class="new-section-div">
    <section class="login-page-section-top blog-title-section">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 size-img back-img">
                    <div class="effect-cover">
                        <h3 class="txt-advert animated fadeInUp">TPL News</h3>
                    </div>
                </div>
            </div>
        </div>
        <div *ngFor="let banner of bannerImageList " class="swiper-slide zoom-effect-container banner-image-div">
            <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
                <div class="headings image-card">
                    <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
                    <div class="slider-inner-div">
                        <div class="container">
                            <div class="main-heading-banner">
                                <!-- <div class="headings-section-banner">
      <h4 class="tracking-in-contract">CREATIVE</h4>
      <div class="main-heading tracking-in-contract new">
        WEB DESIGN.
      </div>
      </div> -->
                                <div class="sldier-bottom-section"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <main class="container blog-details">
        <section class="content my-cont">
            <div *ngIf="newsImage">
                <div class="blog_card">
                    <img src="{{newsImage}}" alt="">
                </div>
            </div>
           <div class="bdy-content">
            <div class="title">
                <h4>{{newsTitle}}</h4> 
             </div>
                <div class="short-discription">
                    <div [innerText]="newsContent"></div>
                </div>
             <!-- <div class="blog-page-content">
                 <div [innerHTML]="newsContent" class="text-div"></div>
     
             </div> -->
           </div>
        </section>
    
    
        <div class="col-md-3 left-news news">
            <div class="right0div">
                <div class="news-headig">
                    <h4>More News</h4>
                </div>
                <div class="center-blog big-news">
                    <div class="swiper blogcenter">
                        <swiper class="swiper-wrapper" fxFlex="auto" [config]="Newscenter_config" [disabled]="disabled"
                            (indexChange)="onIndexChange($event)" (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                            (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                            <!-- <div class="swiper-slide">
                                <div class="banner-image">
                                    <img src="https://devapi.tplsport.com:4600/uploads/newsPic/dcdf244f-a82c-40aa-9828-db4fe184ee36.jpeg" alt="">
                                    <div class="heading w-100">
                                        <h5>test
                                        </h5>
                                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas error ipsam eveniet, tempora commodi hic, aspernatur dolorum modi in exercitationem vel mollitia rem facilis. Rerum minus consequuntur quo ducimus deserunt?
                                        </p>
                                        <div class="date"> <span><i class="bi bi-calendar"></i></span>
                                            10/05/2023</div>
                                    </div>
                                </div>
                            </div> -->
                            <div *ngFor="let news of tplNews " class="swiper-slide">
                                <div class="banner-image">
                                    <img src="{{news.newsImage}}" alt="">
                                    <div class="heading w-100">
                                        <h5>{{news.title}}
                                        </h5>
                                        <p>{{news.description}}</p>
                                        
                                        <div class="date"> <span><i class="bi bi-calendar"></i></span>
                                            {{news.created_at | date:'MMM d, y'}}</div>
                                    </div>
                                </div>
                            </div>
                        </swiper>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
            </div>
        </div>
    
    
        <!-- <div class="col-md-3 left-news news">
            <div class="news-headig">
                <h4>Global</h4>
            </div>
            <div class="swiper blogone">
                <swiper class="swiper-wrapper" fxFlex="auto" [config]="news_config" [disabled]="disabled"
                    (indexChange)="onIndexChange($event)"
                    (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                    (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                    <div *ngFor="let news of espnNews " class="swiper-slide">
                        <a href="{{news.link}}" target="_blank" style="height: 100%;width: 100%;">
                            <div class="news-body">
                                <div class="blog-image">
                                    <img src="{{news.espnImage}}" alt="">
                                </div>
                                <div class="heading">
                                    <h5>{{news.title}}</h5>
                                    <div class="date"> <span><i class="bi bi-calendar"></i></span>
                                        {{news.isoDate | date:
                                        'MMM d, y'}}
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </swiper>
            </div>
        </div>
      -->
    
    
    
        <!-- <aside class="aside">
            <div class="col-md-12 right-column">
                <div class="top-score-title right-title">
                    <h3>Latest News</h3>
                </div>
                <swiper class="swiper-container swiper blogone" fxFlex="auto" [config]="blogs_config" [disabled]="disabled"
                    (indexChange)="onIndexChange($event)" (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                    (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                    <div *ngFor="let blog of blogs " class="swiper-slide">
                        <div class="news-body">
                          
                            <div class="heading">
                                <h5>{{blog.title}}</h5>
                                <div class="date">
                                    {{blog.shortdescription}}
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper>
            </div>
        </aside> -->
    </main>
</div>

